import { Service } from "../../components/test/test.service";
import { AnaColumn } from "../forms-template.service";

export const profiloForm: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Profilo',
      titleForm: '$profiloForm',
      breadcrumbCaption: 'Profilo',
      campoTitle: ['profilo'],
      Service: 'profiloForm',
      masterKey: 'id',
      startTemplate: 'grid',
      allowedAdvancedFilter: true,
      isAdvancedXlsExportAvailable: true,
      filterEditor: '/$',
      formType: 'simple',
      nCol: 2,


    },

  },
  {
    itemType: "group", colSpan: 2, class: 'mt-3', colCount: 2, data: [


      {
        type: 'campo', labelWidth: 120, disabled: true, dataField: 'userName', dataType: "", nCol: 5, hideOnEdit: false, caption: "Username",
        //disabledOnUpdate sembra trattegiato ai bordi

        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },

      {
        type: 'campo', labelWidth: 120, dataField: "telefono", dataType: "", nCol: 5, caption: 'Telefono', editorType: 'dxTextBox',
        //patterns:'^[0-9]+$', //mask non va bene meglio
        validation: [
          { type: "pattern", value: '^[0-9]+$', message: "Il campo Telefono deve contenere solo numeri" },
        ],
      },

      {
        type: 'campo', labelWidth: 120, disableOnUpdate: false, nCol: 5, dataField: 'nomeCompleto', dataType: "", hideOnEdit: false, caption: "Nome Completo",

        validation: [
          { type: "required", message: "Campo Obbligatorio" },

        ],
      },

      {
        type: 'campo', disableOnUpdate: false, labelWidth: 120, nCol: 5, dataField: 'codiceFiscale', dataType: "", hideOnEdit: false, caption: "Codice Fiscale",
        //maxSize: 16,
        maxLength: "16",

        /*
        validation:[
          { type: "stringLength", min: "16", max: "16", message: "Inserire 16 caratteri alfanumerici per il Codice Fiscale" },
        ]
        */
      },
      {
        type: 'campo', defaultValue: true, nCol: 2, labelWidth: 120,
        editorType: 'dxCheckBox', hideOnEdit: false, dataField: "accessoConPIN", caption: "Accesso con Pin", dataType: "boolean",
      },


      {
        type: 'simpleButton', dataField: "cambiaPassword", caption: 'Password',
        colVisible: false, class: 'blueButton text-start text-left',

        nCol: 5,
        button: {
          text: 'Cambio Password',
          name: "cambioPassword",
          event: "cambioPassword",
          class: 'blueButton',
          hint: "Cambia le Credenziali",
          icon: "glyphon icon-locked",
          //related: ['latidudine', 'longitudine'],

        }
      },




      {
        type: 'campo', dataField: 'emailRecupero', labelWidth: 120, nCol: 5, dataType: "", hideOnEdit: false, caption: "Email Recupero",
        //maxSize: 16,
        //maxLength: "16",

      },


      {
        type: 'campo', dataField: 'emailComunicazioni', nCol: 5, dataType: "", hideOnEdit: false, caption: "Email Comunicazioni",
        //maxSize: 16,
        //maxLength: "16",

      },

      {
        type: 'campoDesc',
        caption: "Password", hideInput: true
      },




    ]
  }

]